
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/change-password",
      function () {
        return require("private-next-pages/change-password/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/change-password"])
      });
    }
  